import { LoadingLogo } from '@/components/atoms/LoadingLogo/LoadingLogo'
import CopyrightSection from '@/components/organisms/CopyrightSection/CopyrightSection'
import FooterSynapses from '@/components/organisms/FooterSynapses/FooterSynapses'
import PageWrapper from '@/components/organisms/PageWrapper/PageWrapper'
import React, { Suspense, lazy } from 'react'

// Carga los componentes de manera dinámica
const Header = lazy(async () => await import('@/components/organisms/Header/Header'))
const OurPeopleSectionServicesContainer = lazy(async () => await import('@/components/templates/OurPeopleSectionServicesContainer/OurPeopleSectionServicesContainer'))
const InnovationServices = lazy(async () => await import('@/components/templates/InnovationServices/InnovationServices'))
const WhyChooseSynapsesGroup = lazy(async () => await import('@/components/templates/WhyChooseSynapsesGroup/WhyChooseSynapsesGroup'))
const CarruselBusinessContainerServices = lazy(async () => await import('@/components/templates/CarruselBusiness/CarruselBusinessContainerServices'))
const FormContactSynapses = lazy(async () => await import('@/components/templates/FormContactSynapses/FormContactSynapses'))

export const Services: React.FC = () => {
  const buildDate = new Date().toISOString()

  return (
    <PageWrapper
      title='Synapses Group | Services'
      description='Synapses Group offers secure and innovative solutions for payments the management of business payments, risk management and corporate trade finance. Streamline your business with our expertise.'
      url='https://www.synapses.com'
      keywords={[
        'Synapses Group',
        'BTC TRADING CORPORATION',
        'Trade finance solutions',
        'Trading Corporation',
        'International Financial transactions',
        'Secure International payments',
        'Financial risk management',
        'Specialized financing',
        'Innovative financial services',
        'Global business solutions',
        'International supplier payments',
        'Secure and innovative financial solutions for businesses in Synapses Group.',
        'Optimise your international payments with Synapses Group',
        'Mitigate financial risks and expand globally',
        'Tailor-made trade finance solutions for Synapses Group companies',
        'Secure, efficient and innovative: Synapses Group'
      ]}
      language='en'
      publishedTime={buildDate}
    >
      <Suspense fallback={<LoadingLogo />}>
        <div className='min-h-screen flex flex-col overflow-hidden relative'>
          <Header />
          <main className='flex-grow'>
            <section id='ourPeople' className=''>
              <OurPeopleSectionServicesContainer />
            </section>
            <section id='designingTheFuture' className='lg:pl-[300px] lg:pr-[100px] lg:mt-[150px] lg:mb-[200px]'>
              <InnovationServices />
            </section>
            <section id='whyChoose' className='lg:pl-[300px] lg:pr-[100px] mt-[100px]'>
              <WhyChooseSynapsesGroup />
            </section>
            <section id='clients' className='mt-[100px]'>
              <CarruselBusinessContainerServices />
            </section>
            <section id='formContactSynapses' className='lg:pl-[300px] lg:pr-[100px] mt-[100px]'>
              <FormContactSynapses />
            </section>
          </main>
          <div className=''>
            <FooterSynapses />
          </div>
          <div className=''>
            <CopyrightSection />
          </div>
        </div>
      </Suspense>
    </PageWrapper>
  )
}
